import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { type } from 'os';
import { UploadingToolFileTypesEnum } from 'src/app/enums/uploading-tool-file-type-enums';
import { showNotification } from 'src/app/helpers/show-toast';
import { IExcelTemplateDTO } from 'src/app/_interfaces/uploadingTool/i-excel-templates';
import { FilesService } from 'src/app/_services/files/files.service';
import { UploadingToolService } from 'src/app/_services/uploading-tool/uploading-tool.service';

@Component({
  selector: 'app-uploading-tool',
  templateUrl: './uploading-tool.component.html',
  styleUrls: ['./uploading-tool.component.scss']
})
export class UploadingToolComponent implements OnInit {
  UploadingToolFileTypesEnum: any;

  constructor(private formBuilder: FormBuilder, private uploadingToolService: UploadingToolService,
    private toastr: ToastrService, private filesService: FilesService) { }

  uploadFileForm: FormGroup;
  fileTypes = UploadingToolFileTypesEnum;
  excelTemplates: IExcelTemplateDTO[] = [];

  ngOnInit(): void {
    this.uploadFileForm = this.formBuilder.group({
      file: [null, Validators.required],
      fileTypeId: [null, Validators.required]
    });
    this.uploadingToolService.getExcelTemplates().subscribe({
      next: (res) => {
        this.excelTemplates = res.data;
      },
      complete: () => {
        this.excelTemplates = this.excelTemplates.filter(template => template.id !== 1);
      }
    });
  }

  submit() {
    this.uploadingToolService.uploadExcelSheet(this.uploadFileForm.value.fileTypeId,
      this.uploadFileForm.value.file)
      .subscribe((response) => {
        if (response.data.flag) {
          showNotification('success', 'Sheet has been insterted in the queue', this.toastr);
        }
        else {
          showNotification('danger', response.errorList[0].message, this.toastr);
        }
        this.resetForm();
      });
  }

  downloadTemplate() {
    let templateUrl = this.excelTemplates.find(t => t.id == +this.uploadFileForm.value.fileTypeId).templateUrl;
    this.filesService.downloadFile(templateUrl);
  }


  resetForm() {
    this.uploadFileForm.reset();
    const fileInput = document.getElementById('file') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
}
